import * as React from 'react';

interface Props {
  header?: React.ReactNode;
  children?: React.ReactNode;
  footer?: React.ReactNode;
  className?: string;
}

/**
 * Card with optional header and footer based on
 * https://tailwindui.com/components/application-ui/layout/panels#component-86cba6bd01f8053d3a7f0d071121c1ee
 */
export const Card: React.FC<Props> = (props: Props) => {
  const { className } = props;
  return (
    <div
      className={`relative divide-y divide-gray-300 overflow-hidden rounded-lg bg-white border border-gray-300 shadow ${className}`}
    >
      {props.header && <div className="px-4 py-5">{props.header}</div>}
      {props.children}
      {props.footer}
    </div>
  );
};
Card.displayName = 'Card';
